import React from 'react';
import AlertCircle from 'react-feather/dist/icons/alert-circle';
import { string } from 'prop-types';

import s from './ErrorMessage.css';


/**
 * @param props title - hardcoded description of the error
 * @param props message - hardcoded error message or response from an API
 */
const ErrorMessage = ({ message, title }) =>
    <div
        id="errorMessage"
        className={s.component}
    >
        <AlertCircle
            color="#ff9027"
            size={45}
            className={s.svg}
            id="errorMessage"
        />
        {title &&
            <h3 className={s.emphasis}>
                {title}
            </h3>
        }
        <p>{message}</p>
    </div>;

ErrorMessage.propTypes = {
    message: string,
    title: string,
};

export default ErrorMessage;
